import gql from "graphql-tag";

export const HAMBURGER_MENU_NEW_QUERY = gql`
    query HamburgerMenuNewData($Culture: String) {
        user {
            hamburgerMenuNew(Culture: $Culture) {
                hamburgerMenu {
                    GroupName
                    MenuItemName
                    IsActivated
                    MenuItemDisplayName
                    MenuItemTypeId
                    MenuItemUrl
                    NewTab
                    MenuItemAttributes {
                        MenuItemAttributeName
                        MenuItemAttributeValue
                    }
                    ChildItems {
                        MenuItemName
                        MenuItemDisplayName
                        MenuItemTypeId
                        MenuItemUrl
                        IsActivated
                        MenuItemAttributes {
                            MenuItemAttributeName
                            MenuItemAttributeValue
                        }
                        ChildItems {
                            MenuItemName
                            MenuItemDisplayName
                            MenuItemTypeId
                            MenuItemUrl
                            IsActivated
                            MenuItemAttributes {
                                MenuItemAttributeName
                                MenuItemAttributeValue
                            }
                        }
                    }
                }
                userInfo {
                    firstName
                    lastName
                    photoUri
                }
            }
        }
    }
`;
